var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMirrorDisabled = function SvgMirrorDisabled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.63599,
    y: 0.928955,
    width: 19,
    height: 1,
    rx: 0.5,
    transform: "rotate(45 1.63599 0.928955)",
    fill: "#4C575D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53247 0.5C8.53247 0.223858 8.30861 0 8.03247 0C7.75633 0 7.53247 0.223858 7.53247 0.5V5.41113L8.53247 6.41113V0.5Z",
    fill: "#4C575D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 12.3788L13.7124 11.591C13.7937 11.5337 13.893 11.5 14.0001 11.5C14.2763 11.5 14.5001 11.7239 14.5001 12V12.3788Z",
    fill: "#4C575D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8787 13L11.4154 13.5367C11.3966 13.7957 11.1805 14 10.9167 14H10.5C10.2239 14 10 13.7761 10 13.5C10 13.2239 10.2239 13 10.5 13H10.8787Z",
    fill: "#4C575D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53247 10.6538L7.53247 9.65377V15.5C7.53247 15.7761 7.75633 16 8.03247 16C8.30861 16 8.53247 15.7761 8.53247 15.5V10.6538Z",
    fill: "#4C575D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12134 3H5.50024C5.77639 3 6.00024 2.77614 6.00024 2.5C6.00024 2.22386 5.77639 2 5.50024 2H4.12134L5.12134 3Z",
    fill: "#4C575D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50012 3.62142L2.50012 4.62142V12.5C2.50012 12.7761 2.72398 13 3.00012 13H5.50024C5.77639 13 6.00024 13.2239 6.00024 13.5C6.00024 13.7761 5.77639 14 5.50024 14H3.00012C2.1717 14 1.50012 13.3284 1.50012 12.5V3.62142Z",
    fill: "#4C575D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C10.2239 2 10 2.22386 10 2.5C10 2.77614 10.2239 3 10.5 3H10.9167C11.1928 3 11.4167 2.77614 11.4167 2.5C11.4167 2.22386 11.1928 2 10.9167 2H10.5Z",
    fill: "#4C575D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 2.5C12.0834 2.22386 12.3073 2 12.5834 2H13.0001C13.1336 2 13.2638 2.01757 13.3882 2.0508C13.3972 2.05321 13.4061 2.05586 13.4148 2.05872C13.9137 2.20267 14.3071 2.59824 14.4459 3.09993L14.4493 3.11197C14.4826 3.23629 14.5001 3.36648 14.5001 3.5V4C14.5001 4.27614 14.2763 4.5 14.0001 4.5C13.724 4.5 13.5001 4.27614 13.5001 4V3.85003L13.5 3.83922V3.5C13.5 3.22529 13.2754 3 12.9978 3H12.5834C12.3073 3 12.0834 2.77614 12.0834 2.5Z",
    fill: "#4C575D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 6C14.5001 5.72386 14.2763 5.5 14.0001 5.5C13.724 5.5 13.5001 5.72386 13.5001 6V7C13.5001 7.27614 13.724 7.5 14.0001 7.5C14.2763 7.5 14.5001 7.27614 14.5001 7V6Z",
    fill: "#4C575D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 8.5C14.2763 8.5 14.5001 8.72386 14.5001 9V10C14.5001 10.2761 14.2763 10.5 14.0001 10.5C13.724 10.5 13.5001 10.2761 13.5001 10V9C13.5001 8.72386 13.724 8.5 14.0001 8.5Z",
    fill: "#4C575D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMirrorDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mirror_disabled.4aad420f.svg";
export { ForwardRef as ReactComponent };